/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { useEffect } from "react";
import JwtService from "../../auth/services/jwtService";
import Logo from "../../theme-layouts/shared-components/Logo";

function SignOutPage() {
  useEffect(() => {
    setTimeout(() => {
      JwtService.logout();
    }, 1000);
  }, []);

  return (
    <div className="flex flex-col flex-auto items-center sm:justify-center min-w-0">
      <Paper 
        className="flex items-center w-full sm:w-auto min-h-full sm:min-h-auto rounded-0 py-32 px-16 sm:p-48 sm:rounded-2xl sm:shadow"
        sx={{ backgroundColor: "primary.main" }}
      >
        <div className="w-full max-w-320 sm:w-320 mx-auto sm:mx-0">
          <div className="w-64 mx-auto">
            <Logo />
          </div>
          <Typography className="mt-32 text-4xl font-extrabold tracking-tight leading-tight text-center text-white">
            You have signed out!
          </Typography>
        </div>
      </Paper>
    </div>
  );
}

export default SignOutPage;
